// InternalPageLayout.js
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Accordion, AccordionItem } from "pepsico-ds";
import ListViewDesign from "../InternalPages/ListView/ListViewDesign";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import useThemeRender from "../../theme/useThemeRender";
import "./LibraryAccordion.css";
import { useMediaQuery } from "@mui/material";

import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
export default function LibraryAccordion({ data, subPageId }) {
  const { documents, videos, links } = data;
  const isDarkTheme = useSelector((state) => state.theme);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const textColorLayer4 = useThemeRender("textColorLayer4");

  const navigate = useNavigate();
  const redirectToVisitSubject = (event, data) => {
    navigate(`/library-details/${data?.subjectId}`);
    event.stopPropagation();
  };

  return (
    <Accordion
      className={`library-accordion-container ${
        isDarkTheme ? "dark-theme-text-color" : null
      }`}
      alignment="left"
      onUpdate={function Qa() {}}
      size="xlarge"
      state="enable"
      style={{
        backgroundColor: useThemeRender("backgroundColorLayer2"),
        padding: "0",
        borderRadius: "16px",
      }}
    >
      <AccordionItem
        className="library-accordion-item"
        alignment="right"
        label={
          <span
            style={{
              color: textColorLayer4,
            }}
            className={`${isMobile ? "leading-[20px] text-[14px]" : ""}`}
          >
            {data?.subjectName}
          </span>
        }
        subTitle={
          <button
            style={{
              display: "flex",
              alignItems: "center",
              gap: "var(--Spacing-spacing-4, 4px)",
            }}
            className={`${isMobile ? "text-[12px]" : ""}`}
            onClick={(e) => redirectToVisitSubject(e, data)}
          >
            Visit Subject
            <ArrowForwardIcon
              sx={{
                width: "24px",
                height: "24px",
                top: "2px",
                left: "4px",
                paddingRight: "8px",
              }}
              className={`${isMobile ? "w-[16px] h-[16px]" : ""}`}
            />
          </button>
        }
      >
        <div className={`${isMobile ? "pt-[24px]" : "pt-[38px]"}`}>
          {documents?.length > 0 && (
            <ListViewDesign
              data={documents}
              content={"Documents"}
              pageType="LibraryDetails"
              subPageId={subPageId}
              data-testid="list-view-design"
            />
          )}
          {videos?.length > 0 && (
            <ListViewDesign
              data={videos}
              content={"Videos"}
              pageType="LibraryDetails"
              subPageId={subPageId}
              data-testid="list-view-design"
            />
          )}
          {links?.length > 0 && (
            <ListViewDesign
              data={links}
              content={"Links"}
              pageType="LibraryDetails"
              subPageId={subPageId}
              data-testid="list-view-design"
            />
          )}
        </div>
      </AccordionItem>
    </Accordion>
  );
}
LibraryAccordion.propTypes = {
  data: PropTypes.shape({
    subjectId: PropTypes.number.isRequired,
    subjectName: PropTypes.string.isRequired,
    documents: PropTypes.arrayOf(PropTypes.object),
    videos: PropTypes.arrayOf(PropTypes.object),
    links: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  subPageId: PropTypes.string,
};
